class ArticleClose {
    protected mainButton = $('.b-article-close');
    protected fixButton = $('.article-header-close');
    protected article = $('.b-article');
    protected withPanel = $('body').hasClass('with-panel');
    protected defaultButtonTop = 165;

    constructor() {

        if (this.mainButton.length === 0)
            return;

        $(window)
            .on('resize', () => {
                this.setPosition()
            })
            .on('scroll', () => {
                this.hasScrolled()
            });

        this.setPosition();
        this.hasScrolled();
    }

    setPosition() {
        let left = this.mainButton.offset().left;

        if (window.innerWidth > 1985) {
            this.fixButton.css('left', (window.innerWidth - ((window.innerWidth - 1920) / 2 + 27)) + 'px')
        } else if (window.innerWidth > 768 && window.innerWidth < 993) {
            this.fixButton.css('left', (left + 13) + 'px');
        } else {
            this.fixButton.css('left', (left - 10) + 'px');
        }
    }

    hasScrolled() {
        let st = $(window).scrollTop();
        let panelHeight = +$('#panel').height();
        let offsetTop = (!this.withPanel) ? 200 : panelHeight + 200;
        let articleBottom = this.article.offset().top + this.article.height() + 50;

        /*
        if (st > offsetTop) {
            this.fixButton.fadeIn(200)
        } else {
            this.fixButton.fadeOut(200)
        }
        */

        if (st + this.defaultButtonTop > articleBottom) {
            this.fixButton.css({'top': (articleBottom - st) + 'px'})
        } else {
            this.fixButton.css({'top': this.defaultButtonTop + 'px'})
        }
    }
}

export default ArticleClose;

